import React from 'react';
import Button from '@amzn/awsui-components-console/button';
import Header from '@amzn/awsui-components-console/header';
import Box from '@amzn/awsui-components-console/box';
import { EntityData } from 'src/utils/workflowFilterUtils';

interface WorkflowSplitViewProps {
    workflowsWithRuns: EntityData[];
    workflowsWithoutRuns: any[];
    activeWorkflowType?: string;
    onWorkflowChange: (workflowType: string) => void;
}

const WorkflowSplitView: React.FC<WorkflowSplitViewProps> = React.memo(({
    workflowsWithRuns,
    workflowsWithoutRuns,
    activeWorkflowType,
    onWorkflowChange
}) => {
    return (
        <>
            {workflowsWithRuns.length > 0 && (
                <Box>
                    <Header variant="h3">Workflows with Runs</Header>
                    <Box padding="s">
                        {workflowsWithRuns.map(({ WorkflowType, workflowDefinitionName }, index) => (
                            <Box key={WorkflowType} margin={{ bottom: "xxs" }}>
                                <Button
                                    data-testid={`configListItem-${index + 1}`}
                                    variant="link"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onWorkflowChange(WorkflowType);
                                    }}
                                    id={WorkflowType === activeWorkflowType ? 'activeWorkflow' : undefined}
                                >
                                    {workflowDefinitionName}
                                </Button>
                            </Box>
                        ))}
                    </Box>
                </Box>
            )}
            {workflowsWithoutRuns.length > 0 && (
                <Box>
                    <Header variant="h3">Workflows without Runs</Header>
                    <Box padding="s">
                        {workflowsWithoutRuns.map((workflow, index) => (
                            <Box key={workflow.workflowId} margin={{ bottom: "xxs" }}>
                                <Button
                                    data-testid={`configListItem-without-runs-${index + 1}`}
                                    variant="link"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onWorkflowChange(workflow.workflowId);
                                    }}
                                >
                                    {workflow.workflowDefinitionName}
                                </Button>
                            </Box>
                        ))}
                    </Box>
                </Box>
            )}
        </>
    );
});

export default WorkflowSplitView;
